import React from 'react';

const OurPractices = () => {
  const practices = [
    {
      name: 'Onyx Health Advisory',
      description: 'We partner with government agencies, managed care organizations, hospitals, nonprofits, and life science companies to design and implement actionable strategies that strengthen healthcare delivery and improve program performance.',
      learnMoreURL: '/health-advisory',
      icon: (
        <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      )
    },
    {
      name: 'Onyx Labs',
      description: 'We collaborate with technology companies, data-driven enterprises, and mission-focused organizations to build intelligent systems powered by AI, data engineering, and digital innovation.',
      learnMoreURL: '/onyx-labs',
      icon: (
        <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      )
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-accent mb-6">
            Our Practices
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Expertise that spans two disciplines—and the space where they meet
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {practices.map((practice, index) => (
            <div
              key={index}
              className="bg-gray-50 p-8 lg:p-10 rounded-xl border border-gray-200 hover:shadow-xl transition-all duration-300 flex flex-col"
            >
              <h3 className="text-2xl font-bold text-accent mb-4">
                {practice.name}
              </h3>
              <p className="text-gray-700 leading-relaxed text-lg mb-6 flex-grow">
                {practice.description}
              </p>
              <a
                href={practice.learnMoreURL}
                className="inline-block text-accent font-semibold hover:text-accent-700 transition-colors duration-200"
              >
                Learn more →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurPractices;
